import React from "react";
import ProductDetailHeadingItemNumber from "./ProductDetailHeadingItemNumber";
import QuestionAndAnswerLink from "./QuestionAndAnswerLink";
import ReviewsLink from "./ReviewsLink";

interface ProductDetailHeadingProps {
  itemNumber: string;
  descriptionHtml: string;
  rating: number;
  numberOfReviews: number;
  showVendorItemNumber: boolean;
  actualVendorItemNumber: string;
  isEverLiving: boolean;
  isOutlet?: boolean;
  numberOfAnswers?: number;
  isGroupMaster?: boolean;
  minimalPageVersion?: boolean;
}
const ProductDetailHeading = ({
  itemNumber,
  descriptionHtml,
  rating,
  numberOfReviews,
  showVendorItemNumber,
  actualVendorItemNumber,
  isEverLiving,
  isOutlet = false,
  numberOfAnswers = 0,
  isGroupMaster = false,
  minimalPageVersion = false,
}: ProductDetailHeadingProps) => {
  return (
    <>
      <h1
        className="skip-to-main-target text-base m-0 text-gray-800 font-semibold [text-shadow:0_1px_0_#fff] leading-none xs:leading-4-1/8 md:leading-9 md:mt-1.5 md:text-3xl"
        data-testid="product-detail-heading"
        dangerouslySetInnerHTML={{
          __html: descriptionHtml,
        }}
      />
      <ProductDetailHeadingItemNumber
        itemNumber={itemNumber}
        showVendorItemNumber={showVendorItemNumber}
        actualVendorItemNumber={actualVendorItemNumber}
        className="flex lt:hidden mb-1"
      />
      <div className="flex mb-3 flex-wrap">
        {!!numberOfReviews || !isEverLiving ? (
          <ReviewsLink
            itemNumber={itemNumber}
            minimalPageVersion={minimalPageVersion}
            numberOfReviews={numberOfReviews}
            rating={rating}
          />
        ) : null}
        {!isEverLiving && !isOutlet && !isGroupMaster ? (
          <QuestionAndAnswerLink
            numberOfAnswers={numberOfAnswers}
            className="lt:hidden"
          />
        ) : null}
        <ProductDetailHeadingItemNumber
          itemNumber={itemNumber}
          showVendorItemNumber={showVendorItemNumber}
          actualVendorItemNumber={actualVendorItemNumber}
          className="hidden lt:flex mt-px"
        />
      </div>
    </>
  );
};

export default ProductDetailHeading;
